import { CATEGORY_LABEL } from '@/routes/collective/data/categories';
import { COLLECTIVE_TENANTS } from '@/routes/collective/data/tenants';
import type { CollectiveTenant } from '@/routes/collective/data/types';

export const EMPTY_VALUE = '—';

/**
 * The public tenant record may soon gain optional contact fields (`email`, `phone`).
 * We widen the shared `CollectiveTenant` type locally so this read-only dashboard renders
 * those fields when present and simply omits them when absent — nothing breaks either way.
 */
export type TenantProfile = CollectiveTenant & {
  email?: string;
  phone?: string;
};

export const TENANT_PROFILES: readonly TenantProfile[] = COLLECTIVE_TENANTS;

export function categoryLabel(categoryId: CollectiveTenant['categoryId']): string {
  return CATEGORY_LABEL[categoryId] ?? categoryId;
}

/** Returns the trimmed value, or an em dash placeholder when it is blank. */
export function orDash(value: string | null | undefined): string {
  return value != null && value.trim().length > 0 ? value : EMPTY_VALUE;
}

/** Normalizes a stored website (often bare, e.g. `example.com`) into a safe href. */
export function toWebsiteHref(website: string): string {
  const trimmed = website.trim();
  if (trimmed.length === 0) {
    return '';
  }
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

/** Strips protocol and trailing slash for a compact display label. */
export function toWebsiteLabel(website: string): string {
  return website
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/$/, '');
}
